
































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockTransferView extends Vue {
  public items: Common.StockTransfer[] = new Array(0);
  public params: Common.StockTransferQuery = new Common.StockTransferQuery();
  public importQuery = new Common.ImportQuery('在庫振替','StockTransfer');
  public exportQuery = new Common.ExportQuery('在庫振替',this.params);
  public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'state', text: '状態' },
    { value: 'stockTransferNo', text: '在庫振替番号' },
    { value: 'transferFlag', text: '振替区分' },
    { value: 'bookDate', text: '発生日' },
    { value: 'warehouseOut', text: '出庫倉庫' },
    { value: 'warehouseIn', text: '入庫倉庫' },
    { value: 'segmentOut', text: '出庫部門' },
    { value: 'segmentIn', text: '入庫部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tenantSettings: Common.TenantSettings = null;
  public savingFlag: Common.StockTransferStatus = Common.StockTransferStatus.PostWaiting;
  @Prop() public stockTransferNo:string;

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 100),      
      new Common.GridItemConfiguration('明細番号', 150),
      new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('振替数量', 150),
      new Common.GridItemConfiguration('単価', 150),
      new Common.GridItemConfiguration('金額', 150),
    ],
    10, //金額の次を予備項目の挿入位置に指定
    'col'
  );
  
  public created() {
    this.tenantSettings = this.$api.tenantSettings;
    // 明細の予備項目表示の可変対応
    var reserveItems = this.tenantSettings.GetGridItems(true,true,true,false,false); //商品+在庫(読取のみ)+商品メモ
    this.listGridConfig.setVariableItems(reserveItems);
    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.stockTransferNo) {
      this.params.stockTransferNo = this.stockTransferNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  // 一覧選択時に明細表示ボタンを非活化状態を更新
  public onSelected(index: number, selected: Common.StockTransfer) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);
    this.refreshTransferItemOutList(selected);
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public updateDisabledShowItemButton(stockTransfer:Common.StockTransfer){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetStockTransferItemQuery();
    query.stockTransferNo = stockTransfer.stockTransferNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 明細情報取得・表示
  public isLoading: boolean = false;
  public stockTransferItemsOut: Common.StockTransferItem[]= new Array(0);
  public get totalAmountOut(): number {
    if(this.stockTransferItemsOut.length == 0) return 0;
    return this.stockTransferItemsOut.map(obj => obj.amount).reduce((total, value) =>(total + value));
  }
  public stockTransferItemsIn: Common.StockTransferItem[]= new Array(0);
  public get totalAmountIn(): number {
    if(this.stockTransferItemsIn.length == 0) return 0;
    return this.stockTransferItemsIn.map(obj => obj.amount).reduce((total, value) =>(total + value));
  }
  public refreshTransferItemOutList(stockTransfer:Common.StockTransfer){
    if(stockTransfer.stockTransferNo){
      this.isLoading = true;
      
      var query = new Common.StockTransferItemQuery();
      query.stockTransferNo = stockTransfer.stockTransferNo;
      query.loadAll = true;
      query.state = null;
      // サーバーから明細を取得する
      this.$api.execute(query).then(res => {
        if((this.$refs.mainList as Components.ListView).isInsertMode == false){
          res = res as Common.LoadResult;
          var items: Common.StockTransferItem[] = res.result;
          this.stockTransferItemsOut = items.filter(obj => obj.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales);
          this.stockTransferItemsIn = items.filter(obj => obj.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase);
        }
      }).finally(()=>{
        this.isLoading = false;
      });
    }else{
      this.stockTransferItemsOut = new Array(0);
      this.stockTransferItemsIn = new Array(0);
    }
  }

  // 在庫移動明細一覧を表示
  public showStockTransferItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.StockTransfer;
    let routeData = this.$router.resolve(String.format('/journal/StockTransferItem?stockTransferNo={0}',obj.stockTransferNo));
    window.open(routeData.href, '_blank');
  }

  public async onCreate(obj: Common.StockTransfer) {
    const workflows = this.$api.formatter.getOptions('workflow_stockTransfer');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //在庫振替明細のリロード
    this.refreshTransferItemOutList(obj);    
  }
　

  public showEditor:boolean = false;
  public editItem:any = null;

  public onEdit(item: any){
    this.editItem = item;
    this.showEditor = true;
  }

  public replaceItem(newItem:any){
    //既存明細の更新のみ
    var index = this.stockTransferItemsIn.findIndex(value=>  value.stockTransferItemNo == newItem.stockTransferItemNo);
    if (index > -1) this.$set(this.stockTransferItemsIn, index, newItem);
    index = this.stockTransferItemsOut.findIndex(value=>  value.stockTransferItemNo == newItem.stockTransferItemNo);
    if (index > -1) this.$set(this.stockTransferItemsOut, index, newItem);        
  }

  public async onDelete(transferIn:boolean, item: Common.StockTransfer){

      var selectedItems = transferIn ? (this.$refs.stockTransferItemInBox as Components.Grid).selectedItems:  (this.$refs.stockTransferItemOutBox as Components.Grid).selectedItems;
      if (selectedItems.length == 0){
      this.$api.modal.show('無効な操作', '削除する行を選択してください。', true, null);
      return Promise.reject();        
      }

      return this.$api.modal.showDialog('確認メッセージ', selectedItems.length + '件のデータを本当に削除してよろしいですか?', false).then(async ()=>{
        
        for(let item of selectedItems){        
          await this.$api.remove(item);
        }
        //明細番号が変わるのでリスト全体をリロードする必要がある
        this.refreshTransferItemOutList(item);
        return Promise.resolve();
      });
  }    

  //在庫選択画面を表示して在庫移動を実行する(追加モード)
  public showStockBalance:boolean = false;
  public onAddItems(item : Common.StockTransfer){
    this.editItem = item;
    //在庫移動メニューを起動する
    var stockBalance = this.$refs.stockBalance as Components.StockBalance;
    stockBalance.astrBookDate = item.bookDate;
    stockBalance.astrWarehouseOut = item.warehouseOut;
    stockBalance.astrWarehouseIn = item.warehouseIn;    
    stockBalance.astrPic =item.pic;
    stockBalance.astrWorkflowId = item.workflowId;
    stockBalance.astrClosingDate = item.bookDate;
    stockBalance.astrSegmentOut = item.segmentOut;
    stockBalance.astrSegmentIn = item.segmentIn;    
    stockBalance.astrRefNo = item.refNo;
    stockBalance.astrStockTransfer = item;
    stockBalance.astrUpdatedHandler= this.onComplete;
    stockBalance.showPriviousStockTransferDialog();
  }
  public onComplete() {
    // 在庫移動子画面で保存が成功した場合の後続処理
    // ①在庫選択画面を非表示にする
    // ②明細タブをリロードする        
    this.showStockBalance = false;
    this.refreshTransferItemOutList(this.editItem);
  }    
}
